import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";
import { getOrCreateDeviceId } from "@/utils/deviceId.ts";

interface AuthState {
  accessToken: string | null;
  refreshToken: string | null;
  isAuthenticated: boolean;
  deviceId: string | null;
  userId: string | null;

  initializeDeviceId: () => void;
  setUserId: (id: string) => void;
  setTokens: (accessToken: string, refreshToken: string) => void;
  clearTokens: () => void;
}

export const useAuthStore = create<AuthState>()(
  devtools(
    persist(
      (set) => ({
        accessToken: null,
        refreshToken: null,
        isAuthenticated: false,
        deviceId: null,
        userId: null,

        // Device Id 초기화
        initializeDeviceId: () => {
          const deviceId = getOrCreateDeviceId()
          set({ deviceId })
        },

        // 유저 정보 저장
        setUserId: (id) => set({ userId: id }),

        // 토큰 저장
        setTokens: (accessToken, refreshToken) =>
          set({
            accessToken,
            refreshToken,
            isAuthenticated: true
          }),

        // 토큰 삭제
        clearTokens: () =>
          set({
            accessToken: null,
            refreshToken: null,
            isAuthenticated: false,
            userId: null
          }),
      }),
      {
        name: 'auth-storage',
        partialize: (state) => ({
          accessToken: state.accessToken,
          refreshToken: state.refreshToken,
          deviceId: state.deviceId,
          isAuthenticated: state.isAuthenticated,
          userId: state.userId,
        })
      }
    )
  )
)